"use client";

import { Button } from "@/components/ui/button";
import Link from "next/link";
import { FC } from "react";

interface BackButtonProps {
  href: string;
  label: string;
}
export const BackButton: FC<BackButtonProps> = ({ label, href }) => {
  return (
    <Button variant="link" className="font-normal w-full">
      <Link href={href}>{label}</Link>
    </Button>
  );
};
